import { IProductPageContent } from '@models/IProductPageContent';
import create from 'zustand';

interface IProductPageContentState {
  readonly productPageContent: IProductPageContent;
  readonly setProductPageContent: (
    productContentData: IProductPageContent
  ) => void;
}
const useProductPageContentStore = create<IProductPageContentState>((set) => ({
  productPageContent: {
    compatibleProducts: undefined,
    includedAccessories: undefined,
    optionalAccessories: undefined,
    tabbedProductsCrossSellList: undefined,
    awardsCarousel: undefined,
    breadcrumbs: undefined,
    cardCarousel: undefined,
    featuredImageGallery: undefined,
    productFootnote: undefined,
    productOverview: undefined,
    subheaderStatementCards: undefined,
    technicalSpecifications: undefined,
  },
  setProductPageContent: (productContentData: IProductPageContent) =>
    set({ productPageContent: productContentData }),
}));
export default useProductPageContentStore;
